'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface OverlayBadgeProps {
  children: ReactNode;
  className?: string;
  /** Adds `backdrop-blur` behind the badge. Off by default. */
  blur?: boolean;
}

export const OverlayBadge: FC<OverlayBadgeProps> = ({ children, className, blur = false }) => (
  <div
    className={cn(
      'inline-flex items-center px-2 py-0.5 bg-black/70 rounded-full',
      blur && 'backdrop-blur',
      className,
    )}
  >
    {children}
  </div>
);
